
import numeral from "numeral";
import { useBalanceStore } from "../../../_store/balanceStore";
import {
  DonutChartDebt,
  DonutChartEmpty
} from "../../../components/chart/DonutChartMain";
import { ICON_NAVIGATE_BALANCE } from "../../../utils/useIcons";
import {
  STYLE_BORDER_YELLOW_PROPOTION,
  STYLE_CARD_PROPOTION,
  STYLE_HEADER_SECTION_PROPOTION,
  STYLE_TITLE_PROPOTION
} from "../../../utils/useStyle";
import { BoxWhite } from "../styles/Card";

const ViewDebtProportion = ({ onClick, formBL }) => {
  const setBalanceData = useBalanceStore((state) => state.setBalanceData);
  const balanceData = useBalanceStore((state) => state.balanceData);


  return (
    <div>
      <div className={STYLE_CARD_PROPOTION}>
        <div className={STYLE_HEADER_SECTION_PROPOTION}>
          <div>
            <div className={STYLE_TITLE_PROPOTION}>สัดส่วนหนี้สิน</div>
            <div className={STYLE_BORDER_YELLOW_PROPOTION}></div>
          </div>
          <ICON_NAVIGATE_BALANCE onClick={onClick} />
        </div>

        {balanceData?.debt_propotion <= 0 ||
        balanceData?.debt_propotion === undefined ? (
          <DonutChartEmpty text={`หนี้สิน`} />
        ) : (
          <DonutChartDebt
            text={`หนี้สิน`}
            value={numeral(balanceData?.sum_debt_short+balanceData?.sum_debt_long).format("0,0")}
            // defalut={getDebtBalance > 0 ? 0 : 100}
            data1={balanceData?.sum_debt_short}
            data2={balanceData?.sum_debt_long}
          />
        )}

        <BoxWhite
          title="หนี้สินระยะสั้น"
          icon="/images/debt_short2.png"
          colortext="text-red500"
          value={balanceData?.sum_debt_short}
          info
        />
        <BoxWhite
          title="หนี้สินระยะยาว"
          icon="/images/debt_long2.png"
          colortext="text-mainorange"
          value={balanceData?.sum_debt_long}
          info
        />
      </div>
    </div>
  );
};

export default ViewDebtProportion;
